import { makeStyles } from "@mui/styles";

export const companySection = makeStyles(() => ({
    formContainer: {
        
    },
    editButton: {
        width: 100,
        marginRight: 20,
    },
    deleteButton: {
        color: "#DE350B",
        borderColor: "#DE350B",
        width: 100,
    },
}));
